import type { Address } from 'viem'

export const BICONOMY_VALIDATION_MODULE_ADDRESS: Record<string, Address> = {
	420: '0x5D283bE42cEA50cC74F6CeD79A9844efa34F8A5D',
	10: '0xBB959E12f9cDd7ba5EcEC3662063D9B97f44208a',
	11155420: '0xd722d2C21999F67Cc399EA7c8cF5C5AcBe079DE7',
	84532: '0x3d00a19849f802b7683af7d2f6dba2da2d1526a9',
	8453: '0x342928f9b2b2327b43b0a906468177df5bb3e6fc',
}
